// src/components/modalForm/ModalTable.js
import React, { Children, cloneElement, isValidElement } from 'react';
import './ModalTable.css'; // Importa o CSS personalizado
import { useModalForm } from './ModalFormContext';

const ModalTable = ({ children, containerStyle, containerRef, onContainerScroll, containerClassName = '', className = '', tableRef, emptyMessage = 'Nenhum registro encontrado.', ...tableProps }) => {
  const { variant } = useModalForm();
  const sections = Children.toArray(children);
  const header = sections.find((section) => isValidElement(section) && section.type === 'thead');
  const row = Children.toArray(header?.props.children).find((child) => isValidElement(child) && child.type === 'tr');
  const columns = Children.toArray(row?.props.children).reduce((total, column) => total + (column.props?.colSpan || 1), 0) || 1;
  const content = variant === 'busca' ? sections.map((section) => {
    if (!isValidElement(section) || section.type !== 'tbody' || Children.toArray(section.props.children).length) return section;
    return cloneElement(section, {}, <tr><td colSpan={columns} className="modal-table-empty" role="status">{emptyMessage}</td></tr>);
  }) : children;
  return (
    <div
      ref={containerRef}
      className={`table-container ${containerClassName}`.trim()}
      style={containerStyle}
      onScroll={onContainerScroll}
    >
      <table {...tableProps} ref={tableRef} className={`modal-table ${className}`.trim()}>
        {content}
      </table>
    </div>
  );
};

export default ModalTable;
